function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_84",
  "data-name": "Groupe 84",
  transform: "translate(-244.665 -178)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_83",
  "data-name": "Groupe 83",
  transform: "translate(244.665 178)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_35",
  "data-name": "Trac\\xE9 35",
  d: "M32.551,0h-9.6A6.768,6.768,0,0,0,18.13,2L1.291,18.834a4.412,4.412,0,0,0,0,6.238l9.973,9.973a4.412,4.412,0,0,0,6.238,0L34.34,18.206a6.768,6.768,0,0,0,2-4.817v-9.6A3.79,3.79,0,0,0,32.551,0Zm2.271,13.388a5.263,5.263,0,0,1-1.55,3.746l-16.84,16.84a2.969,2.969,0,0,1-4.1,0L2.362,24a2.9,2.9,0,0,1,0-4.1L19.2,3.066a5.267,5.267,0,0,1,3.747-1.552h9.6a2.274,2.274,0,0,1,2.271,2.271v9.6Z",
  fill: "#676767"
})));

var SvgIcLabel = function SvgIcLabel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36.335,
    height: 36.335,
    viewBox: "0 0 36.335 36.335",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcLabel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_label.cd3fd32a.svg";
export { ForwardRef as ReactComponent };